import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ModalRedirectUserAreaApp } from 'src/app/components/shared/components/modal-redirect-user-area-app/modal-redirect-user-area-app.component';

export interface PartnerRedirectDialogData {
  agencySite: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class PartnerRedirectDialogService {
  private readonly dialogId = 'partner-redirect-dialog';

  constructor(
    private dialog: MatDialog,
    private deviceDetector: DeviceDetectorService
  ) { }

  open(agencySite: string | null): void {
    const alreadyOpen = this.dialog.openDialogs.some((dialogRef) => dialogRef.id === this.dialogId);

    if (alreadyOpen) {
      return;
    }

    const isMobile = this.deviceDetector.isMobile() || this.deviceDetector.isTablet();

    this.dialog.open(ModalRedirectUserAreaApp, {
      id: this.dialogId,
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'partner-redirect-dialog',
      width: isMobile ? '100vw' : '760px',
      maxWidth: isMobile ? '100vw' : '92vw',
      height: isMobile ? '100dvh' : 'auto',
      maxHeight: isMobile ? '100dvh' : '90vh',
      data: { agencySite } as PartnerRedirectDialogData
    });
  }
}
